var exports = {
  "D": "xe564cbfb--92b2ff--title",
};

module.exports = exports;
